/** @format */

import { isRichTextNotEmpty } from '@tenant/app/utils/prismicUtils';

export default {
    methods: {
        isRichTextNotEmpty(field) {
            return isRichTextNotEmpty(field);
        },
    },
};
